import styled from 'styled-components';

import BackgroundImage from '../../assets/home-background.png';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;

  justify-content: center;

  width: 100%;
  height: 100vh;

  background-image: url(${BackgroundImage});
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
`;

export const HalfRectangle = styled.svg`
  position: absolute;
  bottom: 0px;
`;

export const Content = styled.div`
  max-width: 1240px;

  margin: 0 auto;
  padding: 20px;

  text-align: center;

  h1 {
    font-weight: 900;
    font-size: 100px;
    line-height: 75px;

    color: #ffffff;
  }

  @media only screen and (max-width: 1000px) {
    h1 {
      font-size: 12vw;
      line-height: 20vw;
    }
  }
`;

export const LearnMore = styled.div`
  text-align: center;

  div {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 20vh;

    button {
      background: none;
      border: none;

      p {
        transition: color 0.2s;

        font-weight: bold;
        font-size: 20px;
        line-height: 20px;
        text-decoration: none;

        color: #ffffff;
      }

      svg {
        transition: color 0.2s;
        color: #ffffff;

        margin-top: 30px;
        font-size: 40px;
      }

      :hover {
        p,
        svg {
          color: #386882;
        }
      }
    }
  }

  @media only screen and (max-width: 1000px) {
    div {
      button {
        p {
          font-size: 4vw;
        }

        svg {
          margin-top: 14px;
          font-size: 8vw;
        }
      }
    }
  }
`;
